<template>
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel">
    <form class="theme-form theme-form-2 mega-form">
      <div class="card-header-1">
        <h5>Product Information</h5>
      </div>

      <div class="row">
        <div class="mb-4 row align-items-center">
          <label class="form-label-title col-lg-2 col-md-3 mb-0"
            >First Name</label
          >
          <div class="col-md-9 col-lg-10">
            <input class="form-control" type="text" />
          </div>
        </div>

        <div class="mb-4 row align-items-center">
          <label class="col-lg-2 col-md-3 col-form-label form-label-title"
            >Email Address</label
          >
          <div class="col-md-9 col-lg-10">
            <input class="form-control" type="email" />
          </div>
        </div>

        <div class="mb-4 row align-items-center">
          <label class="col-lg-2 col-md-3 col-form-label form-label-title"
            >Password</label
          >
          <div class="col-md-9 col-lg-10">
            <input class="form-control" type="password" />
          </div>
        </div>

        <div class="row align-items-center">
          <label class="col-lg-2 col-md-3 col-form-label form-label-title"
            >Confirm Password</label
          >
          <div class="col-md-9 col-lg-10">
            <input class="form-control" type="password" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
